"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeSummaryStyles = styles_1.makeStyles(function () { return ({
    container: {
        paddingTop: '25px',
    },
}); }, { name: 'GqlSummary_Finance' });
exports.default = financeSummaryStyles;
